import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEdit, faPen } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { JobTypesService } from "../../Services/Api";
import { Link } from "react-router-dom";
import PlusIcon from '../../Assets/Images/CirclePlus.svg'
import toast, { Toaster } from "react-hot-toast";
import DeleteModalComponent from "../../Components/DeleteModalComponent/DeleteModalComponent";
import AddJobTypeModal from "../../Components/JobType/AddJobTypeModal";
import EditJobTypeModal from "../../Components/JobType/EditJobTypeModal";

const JobType = () => {
    const [isDeleteOverlayOpen, setIsDeleteOverlayOpen] = useState(false);
    const [ItemIdToDelete, setItemIdToDelete] = useState('');
    const [jobTypes, setJobTypes] = useState([]);
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [isEditOverlayOpen, setIsEditOverlayOpen] = useState(false);
    const [selectedType, setSelectedType] = useState({});
    useEffect(() => {
        getData();
    }, []);
    async function getData() {
        try {
            const response = await JobTypesService.List();
            setJobTypes(response.content);
        } catch (error) {
            console.error(error);
        }
    }
    const handleAddType = async (name,image) => {
        try {
            await JobTypesService.Add(name , image);
            toast.success('Job type added successfully');
            getData();
        } catch (error) {
            toast.error('Failed to add job type');
        } finally {
            setIsOverlayOpen(false);
        }
    }
    const handleEditType = async (id , name , image) => {
        try {
            await JobTypesService.Edit(id , name  , image);
            toast.success('Job type edited successfully');
            getData();
        } catch (error) {
            toast.error('Failed to edit job type');
        } finally {
            setIsEditOverlayOpen(false);
            setSelectedType({});
        }
    }
    const handleDelete = async (id) => {
        try {
            await JobTypesService.Delete(id);
            toast.success('Job type deleted successfully');
            getData();
        } catch (error) {
            toast.error('Failed to delete job type');
        } finally {
            setItemIdToDelete('');
        }
    };


    return (
        <div className="MainContent JobTypes">
            <div className="Toaster">
                <Toaster position="top-right" reverseOrder={false} />
            </div>
            <AddJobTypeModal
                isOpen={isOverlayOpen}
                onClose={() => setIsOverlayOpen(false)}
                onAddType={handleAddType}
            />
            {selectedType&&
                <EditJobTypeModal
                    isOpen={isEditOverlayOpen}
                    onClose={() => setIsEditOverlayOpen(false)}
                    onEditType={handleEditType}
                    initialData={selectedType}
                />
            }
            <DeleteModalComponent
                id={ItemIdToDelete}
                isOpen={isDeleteOverlayOpen}
                onClose={() => setIsDeleteOverlayOpen(false)}
                onDelete={handleDelete}
            />
            <div className="container">
                <div className="PageHeader">
                    <div className="PageTitle PageTitleSecondary" onClick={() => setIsOverlayOpen(true)}
                    >
                        <img src={PlusIcon} width="20px" height="20px" className="m-1" alt="" />

                        Job Types
                    </div>

                </div>

                <div className="TableContainer container">
                    <div className="row">
                        {jobTypes.map((row) => (
                            <div className="col-lg-12 TableRecord" key={row.id}>
                                <div className="container">
                                    <div className="row">

                                        <div className="col-lg-2 col-md-2 col-sm-2 col-2 Center">
                                            {row.id}
                                        </div>
                                        <Link to={`/jobtypes/${row.id}`} className="nav-link col-lg-4 col-md-4 col-sm-4 col-3 Center">
                                            {row.name}
                                        </Link>
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-2 Center">
                                            <Link to={`/jobtypes/${row.id}`} className="Delete">
                                                <FontAwesomeIcon icon={faEye} />
                                            </Link>
                                        </div>

                                        <div className="col-lg-2 col-md-2 col-sm-2 col-2 Center">
                                            <Link onClick={() => { setIsEditOverlayOpen(true); setSelectedType(row) }} className="Delete">
                                                <FontAwesomeIcon icon={faPen} />
                                            </Link>
                                        </div>
                                        
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-1 Center">
                                            <div className="Delete" onClick={() => {
                                                setItemIdToDelete(row.id);
                                                setIsDeleteOverlayOpen(true);
                                            }}>
                                                <FontAwesomeIcon icon={faTrashAlt} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {jobTypes.length === 0 && (
                            <div className="col-lg-12 text-center">
                                No job types found.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobType;
